import { render, staticRenderFns } from "./NewDataMapper.vue?vue&type=template&id=47004f20"
import script from "./NewDataMapper.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDataMapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewDataMapper.vue?vue&type=style&index=0&id=47004f20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports